export const GoToSectionIcon = ({ fill = '#001965', style }: { fill?: string; style?: any }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
            d="M13.5545 11.1845H7.32361C6.40239 11.1845 5.65625 10.4384 5.65625 9.51714V7.23535"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
            style={style}
        />
        <path
            d="M9.16749 15.0023H4.16541C3.24419 15.0023 2.49805 14.2561 2.49805 13.3349V4.16443C2.49805 3.24321 3.24419 2.49707 4.16541 2.49707H10.0012C10.9224 2.49707 11.6685 3.24321 11.6685 4.16443V4.99811"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M9.16797 9.16645V6.66541C9.16797 5.74419 9.91411 4.99805 10.8353 4.99805H15.8374C16.7586 4.99805 17.5048 5.74419 17.5048 6.66541V15.8359C17.5048 16.7571 16.7586 17.5033 15.8374 17.5033H10.8353C9.91411 17.5033 9.16797 16.7571 9.16797 15.8359V13.3349"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M11.9746 12.7651L13.5544 11.1853L11.9746 9.60547"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);
